// TextCell.tsx
import React, { useState } from 'react';

interface TextCellProps {
  value: any;
  config?: any;
  onChange?: (value: string) => void;
  readOnly?: boolean;
}

export const TextCell: React.FC<TextCellProps> = ({ value, config, onChange, readOnly }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState('');

  let textValue = '';
  try {
    if (typeof value === 'string') {
      textValue = value;
    } else if (value?.text !== undefined) {
      textValue = value.text;
    } else {
      textValue = String(value || '');
    }
  } catch (e) {
    textValue = '';
  }

  const handleStartEdit = () => {
    if (!readOnly) {
      setIsEditing(true);
      setEditValue(textValue);
    }
  };

  const handleSave = () => {
    if (onChange) {
      onChange(editValue);
    }
    setIsEditing(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <input
        type="text"
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        className="w-full px-3 py-1.5 text-sm border border-blue-500 rounded focus:outline-none"
        autoFocus
      />
    );
  }

  return (
    <div
      onClick={handleStartEdit}
      className="w-full px-3 py-1.5 text-sm hover:bg-gray-50 rounded cursor-pointer"
    >
      {textValue || '-'}
    </div>
  );
};
